<template>
  <div id="loading-container">
    <div id="loading">
      <img class="img" src="../img/wd6r6HlME.gif" alt="loading..." />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: 'LoadingScreen',
});
</script>

<style>
#loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent; /* semi-transparent white background */
  z-index: 1000;
}

#loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img {
  height: 100px;
  width: 100px;
  filter: invert(0%) sepia(1780%) saturate(40%);
  background-color: aliceblue;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .img {
    height: 80px;
    width: 80px;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  .img {
    height: 90px;
    width: 90px;
  }
}
</style>
